// extracted by mini-css-extract-plugin
module.exports = {"modal":"style_modal__3WDMF","back":"style_back__28oiR","backDrop":"style_backDrop__2BaGa"};